import { render, staticRenderFns } from "./StyleInfoTab.vue?vue&type=template&id=587d820e&scoped=true"
import script from "./StyleInfoTab.vue?vue&type=script&lang=js"
export * from "./StyleInfoTab.vue?vue&type=script&lang=js"
import style0 from "./StyleInfoTab.vue?vue&type=style&index=0&id=587d820e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d820e",
  null
  
)

export default component.exports